module.exports = __webpack_public_path__ + "static/backgroundProfil-fb15a38a60a2b7962d5ce8465154d68a.jpg";